<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span class="font-weight-light">帕塔的图床</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn flat href="https://github.com/vuetifyjs/vuetify/releases/latest" target="_blank">
        <span class="mr-2">Latest Release</span>
      </v-btn>-->
    </v-toolbar>

    <v-content class="content">
      <!-- <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>拖放文件上传</h3>
      </div>-->
      <!-- <HelloWorld/> -->
      <!-- <v-layout wrap justify-end>
        <v-flex xs12 sm2 d-flex>
          <v-select v-model="hostval" :items="hostlist" item-text="name" item-value="url" solo></v-select>
        </v-flex>
      </v-layout> -->
      <v-data-table :headers="tableHeader" :items="files" class="elevation-1" :pagination.sync="tablecfg" :rows-per-page-items="[
          10,
          50,
          150,
          { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
        ]" rows-per-page-text="每页条数">
        <template v-slot:no-data>
          <v-alert :value="true" type="info">请添加文件</v-alert>
        </template>
        <template v-slot:items="props">
          <td class="text-xs-left tablePic">
            <img v-if="props.item.blob" :src="props.item.blob" alt srcset @load="(x) => readResolution(x, props.item)" />
          </td>
          <td>{{ props.item.name }}</td>
          <td class="text-xs-left">
            <v-icon v-if="props.item.link" dark left color="green darken-2">check_circle</v-icon>
            <v-icon v-else-if="props.item.success" dark left color="red darken-2">cancel</v-icon>
            <!-- <div v-else>{{ props.item.error }}</div> -->
          </td>
          <td class="text-xs-left">{{ props.item.resolution }}</td>
          <td class="text-xs-left">{{ props.item.size | formatSize }}</td>
          <td class="text-xs-left">
            {{ props.item.lastModified | parseDate }}
          </td>
          <td class="text-xs-left">{{ props.item.type }}</td>
          <td class="text-xs-left">{{ props.item.speed | formatSize }}</td>
          <td class="text-xs-left">
            <v-progress-circular :rotate="360" :size="50" :width="5" :value="props.item.progress" color="green">{{ Math.round(props.item.progress) }}</v-progress-circular>
          </td>
          <td class="text-xs-center">
            <v-btn v-if="props.item.link" color="orange darken-2" dark v-clipboard:copy="props.item.link" v-clipboard:success="onCopy" v-clipboard:error="onError">
              <v-icon dark left>file_copy</v-icon>复制链接
            </v-btn>
            <v-btn color="purple darken-2" dark v-if="props.item.link" @click="showQrcode(props.item.link)">
              <v-icon dark left>camera</v-icon>二维码
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <div class="blank"></div>
      <div class="btng between">
        <div class="btng">
          <file-upload ref="upload" accept extensions v-model="files" :multiple="true" :drop="true" name="file" :post-action="uploadUrl" @input-file="inputFile" @input-filter="inputFilter">
            <v-btn color="indigo" dark>
              <v-icon dark left>add</v-icon>选择图片
            </v-btn>
          </file-upload>
          <div v-if="!uploadAuto">
            <v-btn color="info" v-show="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true" type="button">
              <v-icon dark left>backup</v-icon>开始上传
            </v-btn>
            <v-btn color="info" v-show="$refs.upload && $refs.upload.active" @click.prevent="$refs.upload.active = false" type="button">
              <v-icon dark left>warning</v-icon>停止上传
            </v-btn>
          </div>
        </div>
        <div class="right">
          <v-btn color="red accent-2" dark type="button" @click.stop="dialog = true" v-show="files.length">
            <v-icon left>delete_forever</v-icon>清空列表
          </v-btn>
          <!-- <v-btn color="cyan lighten-1" dark type="button" @click.stop="dialogcfg = true">
            <v-icon left>settings</v-icon>配置
          </v-btn> -->
        </div>
      </div>
      <div class="blank"></div>
      <v-flex xs12 sm6 class="flex-toolbar">
        <v-flex xs3 class="text">复制链接：</v-flex>
        <v-flex xs9>
          <v-btn-toggle v-model="outputType">
            <v-btn flat value="str">字符串</v-btn>
            <v-btn flat value="md">Markdown</v-btn>
            <v-btn flat value="arr">数组</v-btn>
            <v-btn flat value="obj1">对象1</v-btn>
            <v-btn flat value="obj2">对象2</v-btn>
            <v-btn flat value="bg">背景</v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-flex>
      <v-textarea name="input-7-1" label="全部链接" :value="outputVal" hint="选择复制"></v-textarea>
    </v-content>
    <div class="tips-alert">
      <div class="tip-text">
        本网站使用 <i>Vue.js</i> 和 <i>Vuetify</i> 构建；图片存储在
        <i>Telegraph</i> ；网站托管于 <i>Cloudflare Pages</i> ；图片使用
        <i>Cloudflare Workers</i> 加速。
      </div>
      <div class="tip-text">
        Cloudflare公司 有能力和动机搜集上传者的信息（包括且不限于 IP 地址，经纬度坐标，设备和浏览器）来配合执法部门的监管。Telegram 上的图片获取到地址之后任何人都可以查看。
      </div>
      <div class="tip-text orange-text">
        上传图片请遵守当地法律法规，不要上传涉及个人隐私的图片，本网站不保证数据安全。
      </div>
    </div>

    <v-footer class="pa-3">
      <v-spacer></v-spacer>
      <div>&copy; {{ new Date().getFullYear() }}</div>
    </v-footer>
    <v-snackbar v-model="snackbar" color="success" :vertical="true" :right="true" :timeout="1500" :top="true">
      {{ snackbarText }}
      <v-btn flat @click="snackbar = false">关闭</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbarErr" color="error" :timeout="1500" :top="true">
      {{ snackbarErrText }}
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">清空文件列表 ?</v-card-title>
        <v-card-text>是否需要清空已经上传的图片列表</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="dialog = false">取消</v-btn>
          <v-btn color="red lighten-1" flat="flat" @click="
              dialog = false;
              obj = {};
              objFull = {};
              taskId = 0;
              $refs.upload.clear();
            ">清空</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showQrDialog" max-width="360">
      <v-card>
        <v-card-title class="headline">链接二维码</v-card-title>
        <v-flex class="text-xs-center">
          <img :src="qrLink" height="300" weight="300" />
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="showQrDialog = false">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogcfg" max-width="500">
      <v-card>
        <v-card-title class="headline">配置</v-card-title>
        <v-card-text>
          <v-layout row wrap align-center>
            <!-- <v-flex xs3>跨域访问：</v-flex>
            <v-flex xs9>
              <v-checkbox v-model="browserType" color="cyan lighten-1" :label="browserType?'允许':'默认'"></v-checkbox>
            </v-flex>-->
            <v-flex xs3>上传方式：</v-flex>
            <v-flex xs9>
              <v-switch v-model="uploadAuto" color="orange darken-3" :label="uploadAuto ? '自动上传' : '手动上传'"></v-switch>
            </v-flex>
            <!-- <v-flex xs3>设置路径：</v-flex> -->
            <!-- <v-flex xs9>
              <v-text-field label="子目录路径" v-model="dir"></v-text-field>
            </v-flex> -->
            <v-flex xs3>文件名HASH：</v-flex>
            <v-flex xs3>
              <v-switch v-model="fileNameHash" color="orange darken-3" :label="fileNameHash ? '有' : '无'"></v-switch>
            </v-flex>
            <v-flex xs4>
              <v-text-field label="设置前缀" inline v-model="tempprefix" v-if="!fileNameHash"></v-text-field>
            </v-flex>
            <!-- <v-flex xs3>展示域名：</v-flex>
            <v-flex xs9>
              <v-radio-group v-model="visitedDomain" row>
                <v-radio color="purple accent-3" label="阿里云" :value="false"></v-radio>
                <v-radio color="purple accent-3" label="代理" :value="true"></v-radio>
              </v-radio-group>
            </v-flex> -->
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="dialogcfg = false">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
/* eslint-disable */
const qr = require("qr-image");
// import HelloWorld from "./components/HelloWorld";
const DATE14 = new Date()
  .toLocaleString("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
  .replace(/\D/g, "");
const DATE8 = new Date()
  .toLocaleString("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })
  .replace(/\D/g, "");
const unidecode = require("unidecode");
export default {
  name: "App",
  components: {
    // HelloWorld
  },
  filters: {
    parseDate(timestamps) {
      if (!timestamps) return "";
      return new Date(timestamps).toLocaleString();
    },
    formatSize(size) {
      if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + " TB";
      } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + " GB";
      } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + " MB";
      } else if (size > 1024) {
        return (size / 1024).toFixed(2) + " KB";
      }
      return size.toString() + " B";
    },
  },
  data() {
    return {
      inputVal: [],
      files: [],
      ossUrl: "",
      ossData: {},
      taskId: 0,
      // dir: "pub/",
      obj: {},
      objFull: {},
      outputVal: "",
      outputValOrigin: [],
      outputType: "str",
      snackbar: false,
      snackbarText: "复制成功！",
      snackbarErr: false,
      snackbarErrText: "",
      tablecfg: {
        descending: false,
        page: 1,
        rowsPerPage: 45, // -1 for All
        sortBy: "",
        totalItems: 100,
      },
      tableHeader: [
        { text: "预览", value: "blob" },
        { text: "原文件名", value: "name" },
        { text: "状态", value: "success" },
        { text: "分辨率", value: "resolution" },
        { text: "大小", value: "size" },
        { text: "修改时间", value: "lastModified" },
        { text: "类型", value: "type" },
        { text: "速度", value: "speed" },
        { text: "进度", value: "progress" },
        { text: "链接", value: "id", align: "center" },
      ],
      uploadAuto: true,
      dialog: false,
      dialogcfg: false,
      browserType: true,
      fileNameHash: true,
      visitedDomain: false,
      tempprefix: DATE8,
      hostval: "",
      // uploadUrl: "https://telegra.ph/upload"
      uploadUrl: "https://box.p0t.top/upload",
      qrLink: "",
      showQrDialog: false,
    };
  },
  watch: {
    // dir: "setLoc",
    uploadAuto: "setLoc",
    browserType: "setLoc",
    fileNameHash: "setLoc",
    visitedDomain: "setLoc",
    outputType: "parseOutPut",
    outputValOrigin: "parseOutPut",
  },
  mounted() {
    // 初始化 host
    // this.hostval = this.hostlist[0].url;
    if (location.hostname !== "localhost") {
      this.uploadUrl = window.location.origin + "/upload";
    }
    let cfg = window.localStorage.getItem("picHelperCfg");
    if (cfg) {
      [
        // this.dir,
        this.uploadAuto,
        this.browserType,
        this.fileNameHash,
        // this.visitedDomain
      ] = JSON.parse(cfg);
      // if (this.dir === undefined) {
      //   this.dir = "";
      // }
      if (this.uploadAuto === undefined) {
        this.uploadAuto = true;
      }
      if (this.browserType === undefined) {
        this.browserType = true;
      }
      if (this.fileNameHash === undefined) {
        this.fileNameHash = true;
      }
    }
  },
  computed: {},
  methods: {
    showQrcode(link) {
      var qr_pic = qr.imageSync(link, { type: "svg" });
      this.qrLink = "data:image/svg+xml," + qr_pic;
      // console.log(" this.qrLink ", this.qrLink);
      this.showQrDialog = true;
    },
    readResolution(x, i) {
      this.$nextTick((_) => {
        if (!x.path && !x.originalTarget) {
          return;
        }
        let obj = {};
        if (/gecko|firefox/gi.test(window.navigator.userAgent)) {
          obj = x.originalTarget;
        } else {
          obj = x.path[0];
        }
        let text = obj.naturalWidth + " x " + obj.naturalHeight;
        i.resolution = text;
      });
    },
    parseOutPut() {
      let val = this.outputType;
      if (val === "obj1") {
        this.outputVal = this.outputValOrigin.map((x) => `{name:"${x.name.replace(/\//g, "_").replace(/\.[\d\w]+$/, "")}", img:"${x.link}"},`).join("\n");
      } else if (val === "obj2") {
        this.outputVal = this.outputValOrigin.map((x) => `{pic:"${x.link}"},`).join("\n");
      } else if (val === "bg") {
        this.outputVal = this.outputValOrigin
          .map(
            (x) =>
              `.image-${unidecode(x.name)
                .replace(/svg|[\ \W]*/g, "")
                .replace(/^(\w)/i, (x) => x.toLowerCase())} {background-image: url('${x.link}');}`
          )
          .join("\n");
      } else if (val === "md") {
        this.outputVal = this.outputValOrigin.map((x) => `![${x.name.replace(/\//g, "_").replace(/\.[\d\w]+$/, "")}](${x.link})`).join("\n");
      } else if (val === "arr") {
        this.outputVal = this.outputValOrigin.map((x) => `"${x.link}",`).join("\n");
      } else {
        this.outputVal = this.outputValOrigin.map((x) => x.link).join("\n");
      }
    },
    setLoc() {
      window.localStorage.setItem(
        "picHelperCfg",
        JSON.stringify([
          // this.dir,
          this.uploadAuto,
          this.browserType,
          this.fileNameHash,
          this.visitedDomain,
        ])
      );
    },
    onCopy: function (e) {
      this.snackbar = true;
      // console.log("You just copied: " + e.text);
    },
    onError: function (e) {
      console.log("Failed to copy texts");
    },
    async customAction(file, component) {
      return;
    },
    /**
     * Has changed
     * @param  Object|undefined   newFile   只读
     * @param  Object|undefined   oldFile   只读
     * @return undefined
     */
    inputFile(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // 获得相应数据
        if (newFile.xhr && newFile.response && newFile.response[0]) {
          //  获得响应状态码
          const link = "https://box.p0t.top" + newFile.response[0].src;
          newFile.link = link;
          this.obj[newFile.id] = link;
          this.objFull[newFile.id] = {
            link: link,
            name: newFile.name,
          };

          // console.log("status", newFile);
        }
      }
      // Automatically activate upload
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (this.uploadAuto && !this.$refs.upload.active) {
          this.$refs.upload.active = true;
        }
      }
      // 添加，更新，移除 后
      this.outputValOrigin = Object.values(this.objFull);
      // this.outputVal = Object.values(this.obj).join("\n");
    },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   读写
     * @param  Object|undefined   oldFile   只读
     * @param  Function           prevent   阻止回调
     * @return undefined
     */
    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // 过滤不是图片后缀的文件
        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          this.snackbarErr = true;
          this.snackbarErrText = "请选择图片文件";
          return prevent();
        }
      }
      // 创建 blob 字段 用于图片预览
      newFile.lastModified = newFile.file.lastModified;
      newFile.blob = "";
      newFile.resolution = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.tablePic {
  img {
    width: 60px;
    height: 60px;
    margin: 15px;
    object-fit: contain;
  }
}

.content {
  margin: 50px;
}

.blank {
  border: 1px;
  height: 50px;
  width: 100%;
}

.btng {
  display: flex;

  &.between {
    justify-content: space-between;
  }
}

.drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;

  h3 {
    margin: -0.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }
}

.flex-toolbar {
  justify-content: flex-start;
  display: flex;
  align-items: center;

  .text {
    margin-right: 15px;
    color: rgba(0, 0, 0, 0.54);
  }
}

.beforetool {
  display: flex;
}

.tips-alert {
  padding: 50px;
  font-size: 11px;

  .tip-text {
    line-height: 2;
    color: #8c8c8c;

    i {
      color: #2196f3;
      font-style: inherit;
      cursor: crosshair;
    }

    &.orange-text {
      color: #ee6400;
    }
  }
}
</style>
